import { gql } from '@apollo/client';
const DUPLICATE_WAREHOUSE_RELEASE = gql `
  mutation DuplicateWarehouseRelease($warehouseReleaseNodeId: ID!) {
    duplicateWarehouseReleaseAsDraft(warehouseReleaseNodeId: $warehouseReleaseNodeId) {
      warehouseRelease {
        id
      }
    }
  }
`;
export default DUPLICATE_WAREHOUSE_RELEASE;
